import FroalaEditor from 'froala-editor';

import { NUM_GROUP_TITLE } from './froalaNumGroupButton';

type Translate = (key: string) => string;

type FroalaLanguagePack = { translation: Record<string, string> };

// De los idiomas de la app Froala solo trae es y pt_br: ca, eu, gl, vl y mx heredan el español, como fallbackLng.
const DEFAULT_FROALA_LANGUAGE = 'es';
const FROALA_LANGUAGE_BY_BASE_LANGUAGE: Record<string, string> = { en: 'en', pt: 'pt_br' };

export function getFroalaLanguage(language?: string | null): string {
  const baseLanguage = (language ?? '').split('-')[0];

  return FROALA_LANGUAGE_BY_BASE_LANGUAGE[baseLanguage] ?? DEFAULT_FROALA_LANGUAGE;
}

/** Los títulos del pack son el nombre accesible de los botones solo icono: los que Froala no trae o traduce mal se sobrescriben. */
export function translateToolbarButtons(t: Translate, froalaLanguage: string): void {
  const packs = FroalaEditor.LANGUAGE as Record<string, FroalaLanguagePack | undefined>;
  const pack = packs[froalaLanguage] ?? { translation: {} };

  packs[froalaLanguage] = pack;
  Object.assign(pack.translation, {
    'Insert math expression': t('common:Insert formula'),
    Edit: t('actions:Edit'),
    Close: t('actions:Close'),
    [NUM_GROUP_TITLE]: t('common:Prevent line break'),
    'Line Height': t('common:Line height'),
    Single: t('common:Single line spacing'),
    Double: t('common:Double line spacing'),
    Default: t('common:Default line spacing'),
    'Text Color': t('common:Text color'),
    'Background Color': t('common:Background color'),
  });
}
